import { useApp } from '@/context/AppContext';
import ChemBar from '@/components/ui/ChemBar';

export default function StopDetailModal({ data }) {
  const { stops, custById, completeStop, openModal, closeModal, setActiveStopId } = useApp();
  const stop = stops.find(s => s.id === data?.stopId);
  const c = stop ? custById(stop.custId) : null;

  if (!stop || !c) return null;

  const handleLogChem = () => {
    openModal('log_chem', { stopId: stop.id, custId: c.id });
  };

  const handleWorkOrder = () => {
    openModal('work_order', { stopId: stop.id });
  };

  const handlePhotos = () => {
    openModal('stop_photos', { stopId: stop.id });
  };

  const handleComplete = () => {
    completeStop(stop.id);
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">{c.name}</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
          {c.gateCode && (
            <div style={{ padding: '7px 12px', background: 'var(--s3)', borderRadius: 8, fontSize: 12.5, color: 'var(--t1)' }}>
              Gate: <strong>{c.gateCode}</strong>
            </div>
          )}
          {c.pets && c.pets !== 'None' && (
            <div style={{ padding: '7px 12px', background: 'var(--s3)', borderRadius: 8, fontSize: 12.5, color: 'var(--amber)' }}>
              {c.pets}
            </div>
          )}
          <div style={{ padding: '7px 12px', background: 'var(--s3)', borderRadius: 8, fontSize: 12.5, color: 'var(--t2)' }}>
            {c.poolGal} gal
          </div>
        </div>

        {c.notes && (
          <div style={{
            padding: '10px 12px',
            background: 'var(--s2)',
            borderRadius: 8,
            fontSize: 12.5,
            color: 'var(--t2)',
            marginBottom: 12,
            lineHeight: 1.55,
          }}>
            {c.notes}
          </div>
        )}

        <div style={{ marginBottom: 12 }}>
          <div style={{
            fontSize: 10.5,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '.07em',
            color: 'var(--t3)',
            marginBottom: 8,
          }}>
            Last Chemistry
          </div>
          {c.chem ? (
            <>
              <ChemBar param="cl"  label="Chlorine"   value={c.chem.cl} />
              <ChemBar param="ph"  label="pH"          value={c.chem.ph} />
              <ChemBar param="alk" label="Alkalinity"  value={c.chem.alk} />
              <ChemBar param="cya" label="CYA"         value={c.chem.cya} />
            </>
          ) : (
            <div style={{ color: 'var(--t3)', fontSize: 12.5 }}>No chemistry logged yet</div>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8 }}>
          <button className="btn btn-ghost" onClick={handleLogChem}>Log Chem</button>
          <button className="btn btn-ghost" onClick={handlePhotos}>Photos</button>
          <button className="btn btn-ghost" onClick={handleWorkOrder}>Work Order</button>
          {stop.status !== 'done' && (
            <button className="btn btn-success" style={{ gridColumn: 'span 3' }} onClick={handleComplete}>Complete Stop</button>
          )}
        </div>
      </div>
    </div>
  );
}
